module.exports = {
  CHARTS_COLORS: {
    baseBlue: '#1d6ae5',
    baseGreen: '#007E62',
    baseOrange: '#ff5f00',
  },
  BRAND_COLORS: {
    baseRed: '#E34400',
  },
};
